export default "__VITE_ASSET__yXBKGAKH__"